import { render, staticRenderFns } from "./BsTextArea.vue?vue&type=template&id=3098fedb&scoped=true&"
import script from "./BsTextArea.vue?vue&type=script&lang=js&"
export * from "./BsTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3098fedb",
  null
  
)

export default component.exports